/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuditType } from '../models/AuditType';
import type { EventAuditLogData } from '../models/EventAuditLogData';
import type { OrderAuditLogData } from '../models/OrderAuditLogData';
import type { PaymentLinkAuditLogData } from '../models/PaymentLinkAuditLogData';
import type { VoucherAuditLogData } from '../models/VoucherAuditLogData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AuditLogService {
  /**
   * Get Audit Logs
   * @param auditTypes Filter by audit type
   * @param eventId Filter by event ID
   * @param orderNumber Filter by order number (returns enriched flow data)
   * @param startDate Filter from date (YYYY-MM-DD format)
   * @param endDate Filter to date (YYYY-MM-DD format)
   * @param page Page number
   * @param perPage Items per page
   * @returns any Successful Response
   * @throws ApiError
   */
  public static getAuditLogs(
    auditTypes?: Array<AuditType> | null,
    eventId?: string | null,
    orderNumber?: number | null,
    startDate?: string | null,
    endDate?: string | null,
    page: number = 1,
    perPage: number = 50,
  ): CancelablePromise<Array<OrderAuditLogData | EventAuditLogData | VoucherAuditLogData | PaymentLinkAuditLogData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/audit-log/items',
      query: {
        audit_types: auditTypes,
        event_id: eventId,
        order_number: orderNumber,
        start_date: startDate,
        end_date: endDate,
        page: page,
        per_page: perPage,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Get Audit Logs By Flow Chain Id
   * @param flowChainId Flow chain ID to filter by
   * @returns any Successful Response
   * @throws ApiError
   */
  public static getAuditLogsByFlowChainId(
    flowChainId: string,
  ): CancelablePromise<Array<OrderAuditLogData | EventAuditLogData | VoucherAuditLogData | PaymentLinkAuditLogData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/audit-log/flow-chain',
      query: {
        flow_chain_id: flowChainId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
